var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66648 0C9.42783 0 11.6663 2.18803 11.6663 4.88709C11.6663 7.58614 9.42783 9.77415 6.66648 9.77415C3.90513 9.77415 1.66662 7.58614 1.66662 4.88709C1.66662 2.18803 3.90513 0 6.66648 0ZM0.83331 18C0.373086 18 0 17.6353 0 17.1855V15.4757C0 13.2266 1.86542 11.4032 4.16655 11.4032H9.167C11.4681 11.4032 13.3336 13.2266 13.3336 15.4757V17.1855C13.3336 17.6353 12.9605 18 12.5002 18C12.04 18 1.29353 18 0.83331 18ZM11.457 9.41852C12.6183 8.24583 13.333 6.64805 13.333 4.88709C13.333 3.12613 12.6183 1.52832 11.457 0.355634C12.0363 0.126292 12.6695 0 13.333 0C16.0943 0 18.3328 2.18803 18.3328 4.88709C18.3328 7.58614 16.0943 9.77415 13.333 9.77415C12.6695 9.77415 12.0363 9.64789 11.457 9.41852ZM13.2493 11.4032H15.8335C18.1346 11.4032 20 13.2266 20 15.4757V17.1855C20 17.6353 19.6269 18 19.1667 18H14.8579C14.95 17.7452 15.0002 17.471 15.0002 17.1855V15.4757C15.0002 13.8804 14.3298 12.4381 13.2493 11.4032Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/Members.585291f0bb4b83657e2e8385986796df.svg";
export { ForwardRef as ReactComponent };